// Analyses Thermostats search routes
export default [
  {
    path: 'analyses-thermostats-search',
    name: 'analysesThermostatsSearch',
    redirect: 'analyses-thermostats-search/index',
    component: () =>
      import(
        /* webpackChunkName: "analysesThermostatsSearch" */ '../views/analysesThermostatsSearch/AnalysesThermostatsSearch.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'analysesThermostatsSearchIndex',
        meta: {
          tabbable: true,
          tableKeys: [],
          filterKeys: [],
          formKeys: ['analysesThermostatsSearch'],
          routePermissions: ['thermostatSearchManage'],
        },
        component: () =>
          import(
            /* webpackChunkName: "analysesThermostatsSearchIndex" */ '../views/analysesThermostatsSearch/AnalysesThermostatsSearchIndex.vue'
          ),
      },
    ],
  },
];
